import React from 'react';
import {
  TEXT_EDITOR_PAGE_SHEET_GAP_PX,
  getTextEditorPageSheetOuterHeightPx,
  getTextEditorPageSheetOuterWidthPx,
} from './textEditorPageLayout';

/**
 * Non-interactive stacked A4 sheets with page numbers (portrait or landscape).
 */
export default function StorageBoxDocumentPageGuides({
  pageCount,
  pageOrientation,
  showPageNumbers = true,
  fullWidth = false,
}) {
  const count = Math.max(1, Number(pageCount) || 1);
  const sheetWidth = getTextEditorPageSheetOuterWidthPx(pageOrientation);
  const sheetHeight = getTextEditorPageSheetOuterHeightPx(pageOrientation);

  return (
    <div
      className="wfm-text-editor__page-stack"
      aria-hidden="true"
      style={{
        width: fullWidth ? '100%' : sheetWidth,
        minHeight: fullWidth
          ? undefined
          : count * sheetHeight + (count - 1) * TEXT_EDITOR_PAGE_SHEET_GAP_PX,
      }}
    >
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className="wfm-text-editor__page-sheet"
          style={
            fullWidth
              ? { marginBottom: index < count - 1 ? TEXT_EDITOR_PAGE_SHEET_GAP_PX : 0 }
              : {
                  height: sheetHeight,
                  marginBottom: index < count - 1 ? TEXT_EDITOR_PAGE_SHEET_GAP_PX : 0,
                }
          }
        >
          {showPageNumbers ? (
            <span className="wfm-text-editor__page-number">{index + 1}</span>
          ) : null}
        </div>
      ))}
    </div>
  );
}
